import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BsCheckLg, BsInfoCircle } from "react-icons/bs";
import { motion } from "framer-motion";
import {
  pricingTabs,
  pricingPlans,
} from "../Data";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.15,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    scale: 0.96,
    filter: "blur(8px)",
  },
  visible: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const featureVariant = {
  hidden: {
    opacity: 0,
    x: -12,
  },
  visible: {
    opacity: 1,
    x: 0,
  },
};

const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const PricingPlans = () => {
  const [activeTab, setActiveTab] = useState("Yearly");

  return (
    <section className="pricing-section">

      <div className="container">

        {/* Heading */}

       <div className="feature-heading">
      
                <motion.div
                  className="feature-left"
                  variants={fadeUpVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <h2 className="section-heading">
                   Start free. Scale <span>when you're ready.</span>
                  </h2>
                </motion.div>
      
                <motion.div
                  className="feature-right"
                  variants={fadeUpVariants}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <motion.div
          className="pricing-tabs"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >

          {pricingTabs.map((tab) => (

            <motion.button
              key={tab}
              layout
              whileTap={{
                scale: .97,
              }}
              className={
                activeTab === tab
                  ? "pricing-tab active"
                  : "pricing-tab"
              }
              onClick={() => setActiveTab(tab)}
            >

              {activeTab === tab && (

                <motion.div
                  layoutId="pricingTab"
                  className="pricing-active-bg"
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 28,
                  }}
                />

              )}

              <span className="pricing-tab-text">

                {tab}

              </span>

            </motion.button>

          ))}

        </motion.div>

                </motion.div>
      
              </div>

        {/* Offer */}

       {/* <motion.div
          className="pricing-offer"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{ delay: .15 }}
          whileHover={{
            scale: 1.01,
          }}
        >

          <div className="offer-left">

            <motion.span
              className="offer-tag"
              initial={{
                opacity: 0,
                scale: .8,
              }}
              whileInView={{
                opacity: 1,
                scale: 1,
              }}
              transition={{
                delay: .25,
                type: "spring",
                stiffness: 220,
              }}
              viewport={{ once: true }}
            >
              {pricingOffer.title}
            </motion.span>

            <h3 className="card-heading">
              {pricingOffer.heading}
            </h3>

            <p className="section-text">
              {pricingOffer.desc}
            </p>

          </div>

          <motion.div
            className="offer-save"
            initial={{
              opacity: 0,
              scale: .9,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              delay: .25,
            }}
            viewport={{ once: true }}
          >

            <h3>{pricingOffer.save}</h3>

            <span>
              you save
            </span>

          </motion.div>

          <motion.div
            className="offer-price"
            initial={{
              opacity: 0,
              scale: .9,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              delay: .35,
            }}
            viewport={{ once: true }}
          >

            <h3>
              {pricingOffer.price}
            </h3>

            <span>
              <del>
                Instead of {pricingOffer.oldPrice}/mo
              </del>
            </span>

          </motion.div>

          <motion.div
            className="offer-right"
            initial={{
              opacity: 0,
              x: 20,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              delay: .45,
            }}
            viewport={{ once: true }}
          >

            <p className="section-text">
              {pricingOffer.sideText}
            </p>

            <motion.a
              href="https://app.onbbits.io/register"
              className="offer-btn btn"
              whileHover={{
                scale: 1.05,
              }}
              whileTap={{
                scale: .96,
              }}
            >
              {pricingOffer.cta}
            </motion.a>

          </motion.div>

        </motion.div>*/}


        {/* Pricing Grid */}

          <motion.div
            className="pricing-grid"
            variants={stagger}
            initial="hidden"
            animate="visible"
            exit={{
              opacity: 0,
              filter: "blur(8px)",
            }}
          >
            {pricingPlans[activeTab].map((plan, cardIndex) => (

  <motion.div

    key={plan.id}

    variants={cardVariant}

    whileHover={{
      scale: 1.02,
      transition: {
        duration: .25,
      },
    }}

    className={
      plan.popular
        ? "pricing-card featured"
        : "pricing-card"
    }

  >

    {/* Icon */}

    <div className="pricing-card-top">

      <motion.div

        className="pricing-icon"

        whileHover={{
          scale: 1.08,
        }}

        transition={{
          type: "spring",
          stiffness: 260,
        }}

      >

        <img
          src={plan.icon}
          alt={`${plan.title} Plan | Onbbits`}
        />

      </motion.div>

      <div>

        <motion.h3

          className="card-heading"

          initial={{
            opacity: 0,
            y: 8,
          }}

          animate={{
            opacity: 1,
            y: 0,
          }}

          transition={{
            delay: .08,
          }}

        >

          {plan.title}

        </motion.h3>

      </div>

    </div>

    <motion.p

      className="section-text top-pricing-text"

      initial={{
        opacity: 0,
      }}

      animate={{
        opacity: 1,
      }}

      transition={{
        delay: .15,
      }}

    >

      {plan.subtitle}

    </motion.p>

    {/* Price */}

    <motion.div

      className="price-wrapper"

      initial={{
        opacity: 0,
        scale: .95,
      }}

      animate={{
        opacity: 1,
        scale: 1,
      }}

      transition={{
        delay: .18,
      }}

    >

      <h3 className="card-heading">

        {plan.price}

        <span>
          {plan.duration}
        </span>

      </h3>

      <p>
        {plan.note}
      </p>

    </motion.div>

    {/* Features */}

    <motion.div

      className="pricing-features"

      variants={stagger}

      initial="hidden"

      animate="visible"

    >

      {plan.features.map((feature, index) => (

        <motion.div

          key={index}

          className="pricing-feature"

          variants={featureVariant}

          transition={{
            delay: index * .05,
          }}

        >

          <motion.div

            whileHover={{
              scale: 1.2,
              rotate: 10,
            }}

          >

            <BsCheckLg />

          </motion.div>

          <span>

            {feature}

          </span>

        </motion.div>

      ))}

    </motion.div>

    {/* WhatsApp Charges PDF */}

{/* WhatsApp Conversation Charges */}

<div className="pricing-pdf-box">

  <div className="pricing-pdf-header">
    <a
      href="/message-template-charges.pdf"
      target="_blank"
      rel="noopener noreferrer"
    >
      <BsInfoCircle />
      <span>WhatsApp Conversation Charges (per message)</span>
    </a>
  </div>

  <div className="pricing-charge-list">

    <div className="pricing-charge-item">
      <span>Marketing</span>
      <strong>₹0.95</strong>
    </div>

    <div className="pricing-charge-item">
      <span>Utility</span>
      <strong>₹0.127</strong>
    </div>

    <div className="pricing-charge-item">
      <span>Authentication</span>
      <strong>₹0.127</strong>
    </div>

    <div className="pricing-charge-item">
      <span>Service</span>
      <strong>₹0.127</strong>
    </div>
  </div>
        <div className="pricing-pdf-special-note">
      <span>1,000 free Service Messages/month</span>
  </div>

</div>

    {/* CTA */}

    <div className="pricing-btn-wrap">

      <motion.a

        href={plan.link}
        target="_blank"
        rel="norefferer"

        whileHover={{
          scale: 1.05,
        }}

        whileTap={{
          scale: .96,
        }}

        className={
          plan.popular
            ? "pricing-btn active-btn btn"
            : "pricing-btn btn"
        }

      >

        {plan.button}

      </motion.a>

    </div>

  </motion.div>

))}
          </motion.div>

        {/* Bottom */}

        <motion.div
          className="pricing-bottom"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          transition={{
            delay: 0.2,
          }}
        >
          <p className="section-text">Meta's messaging fees are separate — we'll explain exactly what to expect on the demo call.</p>

          <p className="section-text">

            Want every detail?

            <motion.a
              href="/pricing#compare-all-plans"
              whileHover={{
                color: "#0FAE4D",
              }}
            >
              Compare all plans
            </motion.a>

            {" "}or{" "}

            <Link
              to="/book-a-demo"
              whileHover={{
                color: "#0FAE4D",
              }}
            >
              Book a Demo
            </Link>
             .
          </p>

        </motion.div>

      </div>

    </section>
  );
};

export default PricingPlans;